import { reduce, endsWith } from 'lodash';
import { urijs } from '../helpers/urijs';
import { readableUrl } from './uri';
export const getCategoryUrl = (sectionUrl, path, slug) => {
    if (sectionUrl) {
        const segments = [path, slug];
        if (endsWith(slug, '/')) {
            segments.push('');
        }
        return readableUrl(reduce(segments, (url, segment) => url.segment(segment), new urijs(sectionUrl)).toString());
    }
    return '';
};
//# sourceMappingURL=get-category-url.js.map